import taskEventTitle from './taskEventTitle'

// Zoeken in de agenda: een afspraak terugvinden zonder te weten wanneer hij
// was (updateverzoek BuurtKlusBedrijf, 2026-09-21).
//
// WAAROM OVER ALLE AFSPRAKEN EN NIET OVER WAT IN BEELD STAAT: 'terugvinden'
// betekent dat je de datum juist NIET weet. Een filter op de zichtbare week
// beantwoordt die vraag niet — dan moet je maand voor maand vooruitklikken en
// bij elke stap opnieuw zoeken. De grootste organisatie heeft 239 afspraken,
// dus ze passen allemaal in één lees.

/** Hieronder levert zoeken vooral ruis op; één letter matcht bijna alles. */
const MIN_TERM_LENGTH = 2

/**
 * Alles waarin gezocht wordt, als één stuk tekst.
 *
 * De titel via `taskEventTitle`, want dát is wat de gebruiker in de agenda
 * ziet staan — een huisbezoek heet in de database 'Huisbezoek' en op het scherm
 * 'Huisbezoek — Europalaan 40'. Zoeken op wat er niet op het scherm staat levert
 * treffers op die niemand kan thuisbrengen.
 *
 * De bewonersnaam staat er apart bij: die staat als tweede regel in het blok en
 * is precies waar iemand op zoekt ('dat bezoek bij De Wit').
 *
 * @param {object} task - Een Tasks-document
 * @returns {string} Kleine letters, om op te vergelijken
 */
const taskSearchText = (task) => [
    taskEventTitle(task),
    task?.Description || '',
    task?.AdressName || '',
].join(' ').toLowerCase()

/**
 * De afspraken die bij een zoekterm passen.
 *
 * Subtaken doen niet mee: die staan niet in de agenda, dus een treffer erop zou
 * naar een blok wijzen dat er niet is.
 *
 * Sorteren op datum, nieuwste eerst — wie iets terugzoekt bedoelt meestal iets
 * van kortgeleden. Een afspraak zonder datum zakt naar onderen in plaats van
 * bovenaan te landen.
 *
 * @param {Array<object>} [tasks] - Alle Tasks-documenten van de organisatie
 * @param {string} [term] - Wat de gebruiker typte
 * @returns {Array<object>} Leeg bij een te korte term
 */
const searchTasks = (tasks, term) => {
    const zoek = (typeof term === 'string' ? term : '').trim().toLowerCase()
    if (zoek.length < MIN_TERM_LENGTH) return []

    const alle = Array.isArray(tasks) ? tasks : []

    return alle
        .filter((task) => {
            if (!task || task.Deleted === true) return false
            // Een subtaak hangt onder een afspraak en heeft geen eigen blok.
            if (task.Parent) return false
            return taskSearchText(task).includes(zoek)
        })
        .sort((a, b) => (b?.Timestamp?.toMillis?.() || 0) - (a?.Timestamp?.toMillis?.() || 0))
}

export { MIN_TERM_LENGTH, taskSearchText }
export default searchTasks
